import React from "react";
import Layout1 from "../../Layouts/Layout1";

const Commercial = () => {
  return (
    <>
      <div className="px-5 pt-3">
        <div className="container mx-auto">
          <main className="h-screen w-full flex flex-col justify-center items-center">
            <h1 className="text-4xl font-extrabold text-[#E5002A] tracking-widest">
              Coming Soon...
            </h1>
          </main>
        </div>
      </div>
    </>
  );
};

export default Commercial;
